var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.params.data != undefined)?_c('button',{staticClass:"btn btn-cp",staticStyle:{"width":"100%","font-size":"11px","padding":"0px","margin":"0px"},on:{"click":function($event){return _vm.fillViewMailModalData(_vm.params.data)}}},[_vm._v("   View ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }